/**
 * Maps `?status=…` on payment return URLs to a coarse UI bucket when the summary API errors.
 * Add new values your PSP sends as new rows (uppercase key → bucket).
 */
export type ParsedPaymentUrlStatus =
  | 'EXPIRED'
  | 'SUCCESS'
  | 'FAILURE'
  | 'CANCELLED'
  | 'PENDING'
  | 'REFUNDED';

const URL_STATUS: Record<string, ParsedPaymentUrlStatus> = {
  EXPIRED: 'EXPIRED',
  EXPIRE: 'EXPIRED',
  SUCCESS: 'SUCCESS',
  OK: 'SUCCESS',
  PAID: 'SUCCESS',
  COMPLETED: 'SUCCESS',
  COMPLETE: 'SUCCESS',
  SUCCEEDED: 'SUCCESS',
  DONE: 'SUCCESS',
  FAILED: 'FAILURE',
  FAILURE: 'FAILURE',
  DECLINED: 'FAILURE',
  ERROR: 'FAILURE',
  REJECTED: 'FAILURE',
  DENIED: 'FAILURE',
  COMPLETED_WITH_ERROR: 'FAILURE',
  COMPLETED_WITH_ERR: 'FAILURE',
  NOT_SUCCESS: 'FAILURE',
  CANCELLED: 'CANCELLED',
  CANCELED: 'CANCELLED',
  CANCEL: 'CANCELLED',
  ABORTED: 'CANCELLED',
  VOIDED: 'CANCELLED',
  USER_ABORTED: 'CANCELLED',
  AUTHENTICATION_FAILED: 'CANCELLED',
  PENDING: 'PENDING',
  PROCESSING: 'PENDING',
  INITIATED: 'PENDING',
  IN_PROGRESS: 'PENDING',
  WEB_FORM_REQUIRED: 'PENDING',
  REFUNDED: 'REFUNDED',
  REFUND: 'REFUNDED',
  REVERSED: 'REFUNDED',
};

export const parsePaymentUrlStatus = (
  raw: string | null | undefined,
): ParsedPaymentUrlStatus | null => {
  if (raw == null || raw === '') {
    return null;
  }
  const key = raw.trim().toUpperCase();
  return URL_STATUS[key] ?? null;
};
